// ---------------------------------------------------------------------------
// Group-by options (consumed by Configure's grouping control)
// ---------------------------------------------------------------------------
export const GROUP_BY_OPTIONS = [
    { value: 'dateOpened', labelKey: 'group_by.date_opened' },
    { value: 'severity', labelKey: 'group_by.severity' },
    { value: 'section', labelKey: 'group_by.section' },
    { value: 'systemAsset', labelKey: 'group_by.system_asset' },
    { value: 'resolutionStatus', labelKey: 'group_by.resolution_status' }
];
// ---------------------------------------------------------------------------
// Default column visibility keys (session-only state; decision 18)
// Required always-visible columns (id, actions/photos) are included because
// ColumnVisibilityControl enforces the `required` flag.
// ---------------------------------------------------------------------------
export const DEFAULT_LINKED_COLUMN_KEYS = [
    'id',
    'question',
    'answer',
    'dateOpened',
    'systemLabel',
    'details',
    'severity',
    'resolutionStatus',
    'includePhotos'
];
export const DEFAULT_CANDIDATE_COLUMN_KEYS = [
    'id',
    'question',
    'answer',
    'dateOpened',
    'systemLabel',
    'details',
    'severity',
    'resolutionStatus'
];
/**
 * Groups view-model rows by the chosen field.
 *
 * The returned groups are suitable for the Quimby Table's `isGrouped=true` +
 * `TableDataGroup[]` data format.  Group titles are the raw string values
 * (already localised on the server for assetDetails; the GroupBy field values
 * for dateOpened / severity / section / systemAsset / resolutionStatus are
 * server strings passed through as-is).
 *
 * Rows with a null group key are collected in a "—" group so they stay visible.
 */
export function groupDeficiencies(rows, groupBy) {
    const FALLBACK = '—';
    const getKey = (row) => {
        var _a, _b, _c, _d;
        switch (groupBy) {
            case 'dateOpened':
                return (_a = row.dateOpened) !== null && _a !== void 0 ? _a : FALLBACK;
            case 'severity':
                return (_b = row.severity) !== null && _b !== void 0 ? _b : FALLBACK;
            case 'section':
                return (_c = row.section) !== null && _c !== void 0 ? _c : FALLBACK;
            case 'systemAsset':
                return row.systemLabel || FALLBACK;
            case 'resolutionStatus':
                return (_d = row.resolutionStatus) !== null && _d !== void 0 ? _d : FALLBACK;
            default:
                return FALLBACK;
        }
    };
    const buckets = rows.reduce((acc, row) => {
        const key = getKey(row);
        const existing = acc.get(key);
        if (existing) {
            existing.push(row);
        }
        else {
            acc.set(key, [row]);
        }
        return acc;
    }, new Map());
    return Array.from(buckets.entries()).map(([title, data]) => ({ title, data }));
}
